import { createContext } from 'react';
import { LocaleData } from '../../models/locale/locale-data';
import { Locales } from '../../models/locale/locales';

export const LocaleContext = createContext({
  locale: '',
  setLocale: (_newLocale: Locales) => {},
  data: null as null | LocaleData,
});
